import React, { Component, Fragment } from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import cx from "classnames";
import { setEnableMobileMenu } from "../../reducers/ThemeOptions";
import {
  DropdownToggle, DropdownMenu,
  UncontrolledButtonDropdown,
  DropdownItem
} from 'reactstrap';
import { checkIsAgencyView, getSessionValue, parseJSON,setSessionValue } from "../../Common/Appcommon";
import Switch from "react-switch";

class BottomNav extends Component {
  constructor(props) {
    super(props);
    let menuList = getSessionValue('menus');
    let isSubAccountView = getSessionValue("isSubAccountView") === 'true' ? true : false;
    let isAgencyView = checkIsAgencyView();
    let menus = (menuList !== '' && menuList !== undefined && menuList !== 'undefined' && menuList !== null) ? parseJSON(menuList) : [];
    this.state = {
      menus: menus,
      activeLinkTo: '/#',
      userProfileName: '',
      isSubAccountView:isSubAccountView,
      agencyView:isAgencyView,
    };
  }
  toggleMobileSidebar = () => {
    let { enableMobileMenu, setEnableMobileMenu } = this.props;
    setEnableMobileMenu(!enableMobileMenu);
  };

  toggleAgencyView = () =>{
    let {agencyView} = this.state;
    this.setState({
      agencyView:!agencyView
    })
    setSessionValue('isAgencyView', !agencyView, 1, "");
    window.location = '#/login_check';
  }

  render() {
    let { menus } = this.state;
    let { notificationCount,showHeaderNoti } = this.props.useThemeFunc;
    if (menus.length === 0) {
      return <Fragment></Fragment>
    }
    let accountMenu = menus[1];
    let cur_url = window.location.hash;
    return (
      <Fragment>
        <div className="metismenu vertical-nav-menu account-settings-menu">
          <ul className="metismenu-container">
            {
              accountMenu.map((menu) => {
                let icon = menu['icon'];
                let label = menu['label'];
                let to = menu['to'];
                let content = menu['content'];
                let badge = menu['badge'];
                if (isNaN(notificationCount)) {
                  notificationCount = 0;
                }
                if(notificationCount > 99){
                  notificationCount = "99+";
                }

                if (content === undefined) {
                  return (
                    <li className={`metismenu-item ${showHeaderNoti && to === '#/profile' ? 'pb-3' : ''}`}>
                      <a onClick={(e) => this.toggleMobileSidebar()} className={cx("metismenu-link d-flex", {"active" : cur_url === to})} href={to}>
                        <i className={`metismenu-icon ${icon}`} />
                        {label}
                        {
                          badge && 
                          <div className="ms-auto d-flex align-items-center">
                            <div className="badge noti-badge">{notificationCount}</div>
                          </div>
                        }
                      </a>
                    </li>
                  )
                }
                return (
                  <Fragment>
                    <UncontrolledButtonDropdown className='metismenu-item help-support-menu unset-btn-group'>
                      <DropdownToggle color="link" className="p-0" >
                        <li className="metismenu-item" key={menu.label}>
                          <a  className="metismenu-link " href={to}>
                            <i className={`metismenu-icon ${icon}`} />
                            {label}
                          </a>
                        </li>
                      </DropdownToggle>
                      <DropdownMenu end className="rm-pointers dropdown-menu-md">
                        {
                          content !== null && content.map((help) => {
                            let label = help['label'];
                            let url = help['url'];
                            return (
                              <DropdownItem className="row m-0">
                                <a target="_blank" rel="noopener noreferrer" className='d-flex col-md-12' href={url}>
                                  <span className="pl-2  col-md-12">{label}</span>
                                  <i className="fi fi-bs-arrow-up-right-from-square col-md-2"></i>
                                </a>
                              </DropdownItem>
                            );
                          })
                        }
                      </DropdownMenu>
                    </UncontrolledButtonDropdown>
                  </Fragment>
                )
              })
            }
            {this.state.isSubAccountView && (
                <div className={showHeaderNoti ? 'pb-3' : ''}>              
                  <span className={`d-flex align-items-center ps-4`}>
                    <div className="pe-4 demon-header mb-1">Agency View</div>
                      <div className="mt-1">
                        <Switch
                          height={20}
                          width={40}
                          className=""
                          onColor={"#23ae73"}
                          onChange={this.toggleAgencyView}
                          checked={this.state.agencyView}
                        />
                      </div>
                    </span>
                  </div>
              )
            }
          </ul>
        </div>
      </Fragment>
    )
  }

  isPathActive(path) {
    return this.props.location.pathname.startsWith(path);
  }
}
const mapStateToProps = (state) => ({
  enableMobileMenu: state.ThemeOptions.enableMobileMenu,
});

const mapDispatchToProps = (dispatch) => ({
  setEnableMobileMenu: (enable) => dispatch(setEnableMobileMenu(enable)),
});
export default connect(mapStateToProps, mapDispatchToProps)(withRouter(BottomNav));
